export type CashFlowsMethodChangeModalContext = {
  currentMethod: string;
  filingId: string;
  orgId: string;
  onSuccess: () => void;
};

let currentContext: CashFlowsMethodChangeModalContext | null = null;

export const CASH_FLOWS_METHOD_CHANGE_MODAL_OPEN_EVENT = 'cashFlowsMethodChangeModal:open';
export const CASH_FLOWS_METHOD_CHANGE_MODAL_CLOSE_EVENT = 'cashFlowsMethodChangeModal:close';

export function setCashFlowsMethodChangeModalContext(ctx: CashFlowsMethodChangeModalContext) {
  currentContext = ctx;
}

export function getCashFlowsMethodChangeModalContext() {
  return currentContext;
}

export function openCashFlowsMethodChangeModal() {
  document.dispatchEvent(new CustomEvent(CASH_FLOWS_METHOD_CHANGE_MODAL_OPEN_EVENT));
}

export function closeCashFlowsMethodChangeModal() {
  document.dispatchEvent(new CustomEvent(CASH_FLOWS_METHOD_CHANGE_MODAL_CLOSE_EVENT));
}
